import ErrorModal from '../../../../components/ui/modal/ErrorModal';
import React, { useEffect, useState } from 'react';
import ModalForm from '../../../../components/ui/ModalForm';
import { Button, Form, Table, TableColumnType, Tooltip } from 'antd';
import InfoModal from '../../../../components/ui/modal/InfoModal';
import { IssueMovement, Movement } from '../../../../types/MaterialRequest';
import { IssuesCloseOutlined } from '@ant-design/icons';
import { BaseModel, FormField, PageableResponse } from '../../../../types';
import { useFetchData, useUpdateStatus } from '../../../../hooks';
import { useMaterialRequestStore } from '../../../../store/MaterialRequestStore';
import { MRS_API } from '../../../../hooks/useMaterialRequestHooks';
import { useAuthStore } from '../../../../store';
import { ColumnsType } from 'antd/es/table';
import { Resource } from '../../../../lib/enums';

const MaterialRequestMovementTable = ({
  movementTable,
  recordId,
  statusRecord,
}: {
  movementTable?: Movement[];
  recordId?: string;
  statusRecord?: string;
}) => {
  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === 'MR',
  );
  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const materialRequestStore = useMaterialRequestStore();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMess, setErrorMess] = useState<string | undefined>('');

  const { data: uomData, isLoading: isUomLoading } = useFetchData<
    PageableResponse<BaseModel>
  >('/product/uoms', {
    resource: Resource.MIN,
    search: '',
    length: '999999',
  });

  const {
    mutate: mutate,
    isError: isUpdateError,
    error: updateError,
    isSuccess,
  } = useUpdateStatus(`${MRS_API}/${recordId}/issue`);

  useEffect(() => {
    if (isSuccess) setIsInfoModalOpen(true);
    if (isUpdateError) {
      setIsErrorModalOpen(true);
      setErrorMess(updateError?.response?.data.message);
    }
  }, [isSuccess, isUpdateError]);

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const onFinish = (value: any) => {
    const data = materialRequestStore.issueMovement;
    const productUom: BaseModel | undefined = uomData?.data?.find((obj) => {
      return (
        obj.id ==
        (typeof value.productUom === 'object'
          ? data?.productUom?.id
          : value.productUom)
      );
    });
    console.log(value);
    console.log(data);
    if (data !== null) {
      data.quantity = value.quantity;
      data.productUom = productUom;
      mutate({
        id: recordId,
        form: data,
      });
    }
  };
  const handleInfoModalClose = () => {
    setIsInfoModalOpen(false);
    setIsErrorModalOpen(false);
  };

  const fields: FormField[] = [
    {
      name: 'product',
      label: 'Product',
      // rules: [{ required: true, message: 'Please select product' }],
      isMultiple: false,
      disabled: true,
      type: 'input',
      defaultValue: materialRequestStore.issueMovement?.product?.description,
    },
    {
      name: 'productUom',
      label: 'UoM',
      // rules: [{ required: true, message: 'Please select product uom' }],
      isMultiple: false,
      disabled: !(
        materialRequestStore.issueMovement?.productUom === null ||
        materialRequestStore.issueMovement?.productUom === undefined
      ),
      type: 'select',
      values: uomData?.data,
      isLoading: isUomLoading,
      rules: [{ required: true, message: 'Please select product UoM' }],
      defaultValue: materialRequestStore.issueMovement?.productUom?.description,
    },
    {
      name: 'quantity',
      label: 'Quantity',
      rules: [{ required: true, message: 'Please input quantity' }],
      isMultiple: false,
      type: 'input',
      defaultValue: materialRequestStore.issueMovement?.quantity,
    },
  ];

  const columns: TableColumnType<Movement>[] = [
    {
      title: 'Code',
      dataIndex: 'productCode',
      render: (_text, record) => <span>{record.product?.code}</span>,
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      render: (_text, record) => <span>{record.product?.description}</span>,
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
    },
    {
      title: 'Proder No',
      dataIndex: 'proderNo',
    },
    {
      title: 'Description',
      dataIndex: 'description',
    },
    // {
    //   title: 'Product UoM',
    //   dataIndex: 'productUoM',
    //   render: (_text, record) => <span>{record.productUom?.description}</span>,
    // },
    // {
    //   title: 'Quantity',
    //   dataIndex: 'quantity',
    // },
    {
      title: 'Request UoM',
      dataIndex: 'requestUoM',
      render: (_text, record) => <span>{record.requestUom?.description}</span>,
    },
    {
      title: 'Request Quantity',
      dataIndex: 'requestQty',
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
    },
  ];
  const [updatedColumns, setUpdatedColumns] =
    useState<ColumnsType<Movement>>(columns);

  useEffect(() => {
    if (user?.role === 'ROLE_ADMIN' || userModuleAccess?.approve) {
      setUpdatedColumns((prevColumns) => {
        const hasActionColumn = prevColumns.some(
          (column) => column.key === 'action',
        );
        if (!hasActionColumn) {
          return [
            ...prevColumns,
            {
              key: 'action',
              title: 'Action',
              dataIndex: 'actions',
              fixed: 'right',
              render: (_text, record) => {
                return (
                  <div className="space-x-1">
                    <Tooltip title="Issue">
                      <Button
                        type="text"
                        disabled={
                          statusRecord === 'DONE' || statusRecord === 'ISSUED'
                        }
                        icon={<IssuesCloseOutlined />}
                        size="middle"
                        onClick={() => {
                          const issueMovement: IssueMovement = {
                            product: record.product,
                            productUom: record.productUom,
                            quantity: record.quantity,
                          };
                          materialRequestStore.setIssueMovement(issueMovement);
                          setModalVisible(true);
                        }}
                      />
                    </Tooltip>
                  </div>
                );
              },
            },
          ];
        }
        return prevColumns;
      });
    }
  }, []);

  return (
    <>
      <Table
        rowKey={(record) => record.id}
        dataSource={movementTable}
        columns={updatedColumns}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
      />
      <ModalForm
        visible={modalVisible}
        onClose={handleCloseModal}
        formFields={fields}
        rowCol={2}
        onFinish={onFinish}
        data={materialRequestStore.issueMovement}
        setData={materialRequestStore.setIssueMovement}
        form={form}
      />

      <ErrorModal
        visible={isErrorModalOpen}
        message={errorMess}
        onClose={handleInfoModalClose}
      />
      <InfoModal
        visible={isInfoModalOpen}
        message={'Movement successfully issued'}
        onClose={handleInfoModalClose}
      />
    </>
  );
};
export default MaterialRequestMovementTable;
